import { render, staticRenderFns } from "./ImagesListPending.vue?vue&type=template&id=9f612e1a&"
import script from "./ImagesListPending.vue?vue&type=script&lang=js&"
export * from "./ImagesListPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports